import { Component, OnInit, HostListener, OnDestroy } from "@angular/core";
import { UntypedFormBuilder, Validators } from '@angular/forms';
import { catchError } from 'rxjs/operators';
import { throwError } from 'rxjs';
import { environment } from '../../../../environments/environment';
import { AlertService } from 'src/app/core/alert/alert.service';
import { AuthService } from 'src/app/core/auth/auth.service';
import { StorageService } from "src/app/core/helpers/storage.service";
import { ValidationService } from 'src/app/core/validation.service';

const inactivityTimeout = environment.inactivityTimeout;

declare var $:any;

@Component({
    selector: "app-user-layout",
    templateUrl: "./user-layout.component.html",
    styleUrls: ["./user-layout.component.scss"],
    standalone: false
})
export class UserLayoutComponent implements OnInit, OnDestroy {
	isExpireLoading: boolean;
  validationMessage: any;
  lastActivityTime: number;
  userInactiveState: boolean = false;
  user = this.storageService.getCurrentUser()?.user?.firstName;
	sessionExpiredForm = this.formBuilder.group({
		username: [""],
		password: ["", Validators.compose([Validators.required])],
	});

  constructor(
    private storageService: StorageService, 
    private formBuilder: UntypedFormBuilder, 
    private authService: AuthService, 
    private alertService: AlertService, 
    private validationMessages: ValidationService,
  ) {
    this.validationMessage = validationMessages;
    this.lastActivityTime = Date.now();
  }

  ngOnInit() {
    $("#sessionExpired").modal("hide");
    this.startInactivityTimer();
    this.user = this.storageService.getCurrentUser().user.firstName;
  }

  initializeForm() {
    this.sessionExpiredForm = this.formBuilder.group({
      username: [""],
      password: ["", Validators.compose([Validators.required])],
    });
  }

  signBackIn(val) {
    val.username = this.storageService.getCurrentUser()?.user.username;
    this.isExpireLoading = true;

    this.authService.login(val).subscribe(
      (response) => {
        this.storageService.storeCurrentUser(response);
        this.isExpireLoading = false;
        $("#sessionExpired").modal("hide");
        this.alertService.success("Session restored, kindly refresh if you can't see your previous data")
      },
      (error) => {
        this.isExpireLoading = false;
        this.alertService.error(error, false);
      }
    );
  }

  // Listen for global events
  @HostListener('document:mousemove', ['$event'])
  @HostListener('document:click', ['$event'])
  @HostListener('document:keydown', ['$event'])
  onActivity(event: Event) {
    this.lastActivityTime = Date.now();
  }

  // Start a timer to check for inactivity
  startInactivityTimer() {
    const intervalId = setInterval(() => {
      const currentTime = Date.now();
      const timeSinceLastActivity = currentTime - this.lastActivityTime;
      if (timeSinceLastActivity >= inactivityTimeout) {
        clearInterval(intervalId); // Clear the interval
        this.alertService.warn("Session Expired");
        setTimeout(() => {
          this.logout();
        }, 2000);
      }
    }, 60000); // Run the function every 1 minute
  }
  

  stayLoggedin() {
    this.userInactiveState = false;
    this.authService.refreshToken().subscribe(
      (res) => {
        this.storageService.storeCurrentUser(res);
      },
      catchError((refreshError) => {
        this.authService.logout();
        return throwError(refreshError);
      })
    )
  }

  logout() {
    this.authService.logout();
  }

	ngOnDestroy() {
    this.storageService.removeAll();
  }
}
